import { type ReactNode, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from './session-provider';
import { CaremoryAiLoader } from '@/components/caremory-ai-loader';
import { stopClarity } from '@/lib/clarity';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { session, loading } = useSession();
  const location = useLocation();

  useEffect(() => {
    stopClarity();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <CaremoryAiLoader size="md" label="Loading…" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
